import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { SettingsModule } from './settings.module';
platformBrowserDynamic().bootstrapModule(SettingsModule);
